export default __webpack_public_path__ + "static/media/airbnb-clone-screen.5ae38053.png";